import { useTargetStatusGroupCounts } from '../../../../../services/modules/target/target.queries';
import { TargetType } from '../../../../../services/modules/target/target.types';
import { UseHasBrandTargetsParams } from '../orderObjectPage.types';

const useHasBrandTargets = ({ enabled }: UseHasBrandTargetsParams) => {
  const customerCounts = useTargetStatusGroupCounts(
    { type: TargetType.BRAND_TO_CUSTOMER },
    { enabled },
  );
  const salesRepresentativeCounts = useTargetStatusGroupCounts(
    { type: TargetType.BRAND_TO_SALES_REPRESENTATIVE },
    { enabled },
  );

  const counts = [customerCounts, salesRepresentativeCounts];

  return {
    hasTargets: counts.some((query) => !!query.data?.total),
    hasFailed: counts.some((query) => query.isError),
    isLoading: counts.some((query) => query.isLoading),
  };
};

export default useHasBrandTargets;
